import { CORAL } from '../theme/creamyTokens';

// Stripe's embedded Connect components render inside a cross-origin iframe
// (connect.stripe.com) -- we can't reach it with our own page CSS, only
// with Connect.js's own "appearance" API (variables + a small set of
// per-element `rules`, same shape as Stripe.js Elements' appearance API).
// This maps that to the app's creamy/pill look: coral primary + pill
// buttons/inputs at the same 16px/999px radii as pillFormTheme.ts. Shared
// between every embedded Connect.js onboarding in the app (PaymentsSection's
// own "Cobros" tab for a Host, ServiceProviderOnboardingWizard for a
// ServiceProvider) so both read as the same component, not two divergent themes.
export const CONNECT_APPEARANCE = {
  variables: {
    colorPrimary: CORAL,
    colorBackground: '#ffffff',
    buttonPrimaryColorBackground: CORAL,
    buttonPrimaryColorText: '#ffffff',
    borderRadius: '16px',
    buttonBorderRadius: '999px',
    formBorderRadius: '16px',
    badgeBorderRadius: '999px',
    spacingUnit: '10px',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
  },
  rules: {
    '.Input': { borderRadius: '16px' },
    '.Label': { fontWeight: '500' },
    '.Button': { borderRadius: '999px' },
    '.Tab': { borderRadius: '999px' },
  },
};
